import { useCallback } from 'react';
import useKeyDown from 'hooks/useKeyDown';
import {
  getIsEditableElement,
  isArrowDownPressed,
  isArrowUpPressed,
} from 'utils';
import { DrawerNavigation } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';

export default function useDrawerKeyboardNavigation({
  onPrev,
  onNext,
}: DrawerNavigation) {
  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (getIsEditableElement(e.target)) return;

      if (isArrowUpPressed(e) && onPrev) {
        e.preventDefault();
        onPrev();
      }

      if (isArrowDownPressed(e) && onNext) {
        e.preventDefault();
        onNext();
      }
    },
    [onNext, onPrev],
  );

  useKeyDown({ onKeyDown, enabled: !!onPrev || !!onNext });
}
